<app-modal class="tickets-create-modal">
    <ng-container modal-header>
        <h4 class="modal-title">{{ 'atom.existing-operations.title' | translate }}</h4>
    </ng-container>
    <ng-container modal-body>
        <br/>
        <div class="row">
            <div class="col-lg-12" class="danger">{{ operationsNames }}</div>
        </div>
        <div class="row" *ngFor="let operation of operationTools">
            <div class="col-lg-12">
                <app-tool-scan-tree
                    labelText="{{getOperationTitle(operation.operationName)}}"
                    [items]="operation.tools">
                </app-tool-scan-tree>
            </div>
        </div>
    </ng-container>
    <ng-container modal-footer>
        <app-button type="primary" (click)="createTicket()">
            {{ 'atom.existing-operations.next'| translate }}
        </app-button>
    </ng-container>
</app-modal>
